// @/lib/dropdowns.js

const titleTranslation = {
  consumables: 'Расходные материалы',
  consumables_expenses: 'Расходные материалы (Расход)',
  consumables_stock: 'Склад Расходные материалы',
  consumables_purchases: 'Склад Закупки Расходные материалы',
  devices: 'Колонки и устройства',
  devices_expenses: 'Колонки и устройства (Расход)',
  devices_stock: 'Склад Колонки и устройства',
  devices_purchases: 'Склад Закупки Колонки и устройства',
  materials_comm: 'Материалы коммерческий',
  materials_comm_expenses: 'Материалы коммерческий (Расход)',
  materials_comm_stock: 'Склад Материалы коммерческие',
  materials_comm_purchases: 'Склад Закупки Материалы коммерческие',
  materials_nd: 'Материал фирмы',
  materials_nd_expenses: 'Материалы фирмы (Расход)',
  materials_nd_stock: 'Склад Материалы фирмы',
  materials_nd_purchases: 'Склад Закупки Материалы фирмы',
  medicines: 'Лекарственные препараты',
  medicines_expenses: 'Лекарственные препараты (Расход)',
  medicines_stock: 'Склад Лекарственные препараты',
  medicines_purchases: 'Склад Закупки Лекарственные препараты',
  medicinal_form: 'Лекарственная форма',
  medicine_trademarks: 'Торговое наименование',
  storage_conditions: 'Условия хранения',
  product_form: 'Форма выпуска',
  orders: 'Заявки',
  packing: 'Фасовка',
  status: 'Статус',
  communication: 'Коммуникация',
  complaints: 'Обращения',
  departments: 'Департаменты',
  transfers: 'Трансферы',
  channel: 'Канал коммуникации',
  archive: 'Архивные папки',
  defect_category: 'Категория дефекта',
  defect_type_bottle: 'Тип дефекта: флакон',
  defect_type_capsule: 'Тип дефекта: Таблетки/Капсулы',
  defect_type_inhaler: 'Тип дефекта: Ингалятор',
  defect_type_respules: 'Тип дефекта: RESPULES (Контейнер)',
  defect_type_sachets: 'Тип дефекта: Пакет (SACHETS)',
  defect_type_software: 'Тип дефекта: Программное обеспечение/ Медицинские приборы',
  defect_type_spray: 'Тип дефекта: Назальный спрей',
  defect_type_syringe: 'Тип дефекта: Шприц-ручка',
  defect_type_sysringe: 'Тип дефекта: PRE-FILLED SYRINGE / ACCESSORIZED PRE-FILLED SYSRINGE',
  event_type: 'Тип события',
  fn_criticality_event: 'Критичность события (ФН)',
  manufacturer_lp: 'Производители лекарственных препаратов',
  country: 'Страны',
  pharm_method: 'Способы получения лекарственных препаратов',
  product_units: 'Единицы измерения',
  provider_name: 'Провайдеры',
  type: 'Тип департамента',
  pharm_country:
    'Страна (для блока Инфомация о месте, где был приобретен препарат, этап Уточнение данных)',
  place_country:
    'Страна (для блока Инфомация о месте, где возникло событие, этап Уточнение данных)',
  registration_country: 'Страна (этап Регистрации)',
  courier: 'Курьерская служба',
}

export function replaceTitle(title) {
  return titleTranslation[title] || title
}
